import { storage, timestamp, firebase } from "../firebase/index";
import md5 from "md5";
import { v4 as uuid } from "uuid";
import jQuery from "jquery";

export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties,
  };
};

function skipNumber(str) {
  // let str =
  //   "......in2.-whey.....-protein-5-lbs-2.33-kg-mango-flavour....a.b.c";

  let newStr = "";
  let dropPostions = []; //i=24
  //3-1415.
  for (let i = 0; i < str.length; i++) {
    if (!isNaN(Number(str.charAt(i)))) {
      //number
      if (str.charAt(i + 1) == ".") {
        // newStr = newStr + str.charAt(i);
        if (!isNaN(Number(str.charAt(i + 2))) && str.charAt(i + 2) != "") {
          // newStr = newStr + str.charAt(i + 1);
          //dot
          i = i + 2;
          while (!isNaN(Number(str.charAt(i))) && i < str.length) {
            //skip
            // newStr = newStr + str.charAt(i);
            i = i + 1; //3
          }
        } else {
          //drop i+1
          dropPostions.push(i + 1);
        }
      } else {
        // newStr = newStr + str.charAt(i);
      }
    } else {
      if (str.charAt(i) == ".") {
        dropPostions.push(i);
      } else {
        // newStr = newStr + str.charAt(i);
      }
    }
  }

  for (let i = 0; i < str.length; i++) {
    if (!dropPostions.includes(i)) {
      newStr = newStr + str.charAt(i);
    }
  }

  dropPostions = [...new Set(dropPostions)];

  return newStr;
}
export function string_to_slug(str) {
  if (!str) {
    return null;
  }
  str = str.replace(/^\s+|\s+$/g, ""); // trim
  str = str.toLowerCase();

  // remove accents, swap ñ for n, etc
  var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
  var to = "aaaaeeeeiiiioooouuuunc------";
  for (var i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
  }

  str = str
    .replace(/[^a-z0-9. -]/g, "")
    // .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
    .replace(/\s+/g, "-") // collapse whitespace and replace by -
    .replace(/-+/g, "-"); // collapse dashes

  return skipNumber(str);
}
export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const generateUniqueId = (length) => {
  let id = md5(
    timestamp + uuid() + Math.random() * 100000 + new Date().getTime()
  );
  return length ? id.substr(0, length) : id;
};

export const uploadImage = (path, file) => {
  return new Promise((resolve, reject) => {
    const uploadTask = storage.ref(path).put(file);
    uploadTask.on(
      "state_changed",
      null,
      (error) => {
        reject(error);
      },
      () => {
        //complete function
        storage
          .ref(path)
          .getDownloadURL()
          .then((url) => {
            resolve(url);
          })
          .catch((error) => {
            reject(error);
          });
      }
    );
  });
};

export const deleteFileFromUrl = (url) => {
  return new Promise(async (resolve, reject) => {
    try {
      await storage.refFromURL(url).delete();
      resolve(true);
    } catch (error) {
      // console.log(JSON.parse(JSON.stringify(error)).code.match("not-found") )
      if (error.toString().match("not-found")) {
        resolve(true);
      } else {
        reject(error);
      }
    }
  });
};
export const getDateFromTime = (time) => {
  let d = new Date(time);
  let month = (d.getMonth() + 1).toLocaleString("en-US", {
    minimumIntegerDigits: 2,
  });
  let date = d.getDate().toLocaleString("en-US", { minimumIntegerDigits: 2 });
  return `${date}/${month}/${d.getFullYear()}`;
};
export const getInputDateFromTime = (time) => {
  //For Date Picker
  let d = new Date(time);
  let month = (d.getMonth() + 1).toLocaleString("en-US", {
    minimumIntegerDigits: 2,
  });
  let date = d.getDate().toLocaleString("en-US", { minimumIntegerDigits: 2 });

  return `${d.getFullYear()}-${month}-${date}`;
};
const createVariant = (arr1, arr2) => {};
//Logic modified for only variants combination not in general combination of any two arrays.
const combine2Arrs = (arr1, arr2, index) => {
  let combinations = [];

  for (let i = 0; i < arr1.length; i++) {
    for (let j = 0; j < arr2.length; j++) {
      // variantId+=arr1[i].
      if (index == 1) {
        combinations.push({
          variantId: [arr1[i].id, arr1[i].value, arr2[j].id, arr2[j].value],
          // variantId:arr1[i].id+arr1[i].value+arr2[j].id+arr2[j].value,
          attributes: {
            [arr1[i].id]: {
              attribute: arr1[i].attribute,
              name: arr1[i].value,
              value: arr1[i].value,
              id: arr1[i].id,
            },
            [arr2[j].id]: {
              attribute: arr2[j].attribute,
              name: arr2[j].value,
              value: arr2[j].value,
              id: arr2[j].id,
            },
          },
        });
      } else {
        let variantId = arr1[i].variantId;
        let attrObj = arr1[i].attributes;
        //arr1[i]+arr2[j]
        combinations.push({
          variantId: variantId.concat(arr2[j].id, arr2[j].value),
          // variantId:variantId+arr2[j].id+arr2[j].value,
          attributes: {
            ...attrObj,
            [arr2[j].id]: {
              attribute: arr2[j].attribute,
              name: arr2[j].value,
              value: arr2[j].value,
              id: arr2[j].id,
            },
          },
        });
      }
    }
  }
  return combinations;
};
//Logic modified for only variants combination not in general combination of  arrays.
export const combineArrs = (comarrs) => {
  try {
    let combinations = comarrs[0];
    //if only one array in comarrs
    if (comarrs.length < 2) {
      let combs = [];
      for (let i = 0; i < combinations.length; i++) {
        combs.push({
          variantId: [combinations[i].id, combinations[i].value],
          // variantId:combinations[i].id+combinations[i].value,
          attributes: {
            [combinations[i].id]: {
              attribute: combinations[i].attribute,
              name: combinations[i].value,
              id: combinations[i].id,
            },
          },
        });
      }

      combs.map((comb) => {
        comb.variantId = md5(comb.variantId.sort().reduce((a, b) => a + b));
      });

      return combs;
    } else {
      for (let i = 1; i < comarrs.length; i++) {
        combinations = combine2Arrs(combinations, comarrs[i], i);
      }

      combinations.map((comb) => {
        comb.variantId = md5(comb.variantId.sort().reduce((a, b) => a + b));
      });
      return combinations;
    }
  } catch (error) {
    return null;
  }
};

export const getShipment = (product, order) => {
  return new Promise(async (resolve, reject) => {
    try {
      let waybill = product.waybill;

      // let id = product.variantId?product.variantId:product.id;

      if (waybill) {
        let packageStatus = order.packageStatus;

        if (packageStatus) {
          if (packageStatus[waybill].ShipmentData) {
            let Shipment = packageStatus[waybill].ShipmentData[0].Shipment;
            if (Shipment) {
              let { StatusType, Status } = Shipment.Status;
              resolve({ StatusType, Status });
            } else {
              resolve({ StatusType: "", Status: "" });
            }
          } else {
            let result = await firebase
              .functions()
              .httpsCallable("trackDelivery")({ waybill: waybill });

            let Shipment = result.data.ShipmentData[0].Shipment;
            if (Shipment) {
              let { StatusType, Status } = Shipment.Status;
              resolve({ StatusType, Status });
            } else {
              resolve({ StatusType: "", Status: "" });
            }
          }
        } else {
          let result = await firebase
            .functions()
            .httpsCallable("trackDelivery")({ waybill: waybill });

          let Shipment = result.data.ShipmentData[0].Shipment;
          if (Shipment) {
            let { StatusType, Status } = Shipment.Status;
            resolve({ StatusType, Status });
          } else {
            resolve({ StatusType: "", Status: "" });
          }
        }
      } else {
        // resolve(false)
        // reject(false)
        resolve({ StatusType: "", Status: "" });
      }
    } catch (error) {
      return resolve({ StatusType: "", Status: "" });
    }
  });
};

export const getShippingStatusForButtons = (product) => {
  getShipment(product).then((response) => {
    // let Shipment = product.Shipment;
    let Shipment = response.ShipmentData[0].Shipment;

    if (Shipment) {
      // console.log(Shipment.Status)
      let { StatusType, Status } = Shipment.Status;
      return StatusType + "_" + Status;
    } else {
      //Tracking still not available
      return "";
    }
  });
};

export const getShippingStatus = (product) => {
  getShipment(product).then((response) => {
    let Shipment = response.ShipmentData[0].Shipment;
    if (Shipment) {
      // console.log(Shipment.Status)
      let { StatusType, Status } = Shipment.Status;

      return { StatusType, Status };
    } else {
      //Tracking still not available
      return "";
    }
  });
};

export const getDiffDays = (date1, date2) => {
  const diffTime = Math.abs(date2 - date1);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
};

export const removeSpecificFromArray = (arr, element) => {
  const index = arr.indexOf(element);
  if (index > -1) {
    arr.splice(index, 1);
  }
  return arr;
};

export const sortArrayObjects = (arr, property) => {
  return arr.sort((a, b) =>
    a[property] > b[property] ? 1 : b[property] > a[property] ? -1 : 0
  );
};
export function shuffleArray(array) {
  var currentIndex = array.length,
    randomIndex;

  // While there remain elements to shuffle...
  while (currentIndex != 0) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }

  return array;
}

export const removeSpecialChars = (name) => {
  return name.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, "");
};
// if(Shipment){
//   // console.log(Shipment.Status)
//     let { StatusType,Status} = Shipment.Status;

//     return Status;

// }else{
//     //Tracking still not available
//     return ""
// }

export const getYoutubeVideoId = (url) => {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);

  return match && match[2].length === 11 ? match[2] : null;
};

export const getEmbedUrlFromYoutubeUrl = (url) => {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);

  let videoid = match && match[2].length === 11 ? match[2] : null;
  if (videoid) {
    return `https://youtube.com/embed/${videoid}`;
  } else {
    return null;
  }
};

export const stringToHTML = function (str) {
  var dom = document.createElement("div");
  dom.innerHTML = str;
  return dom;
};

export const closeAllModal = () => {
  try {
    let modals = document.getElementsByClassName("modal");
    if (modals) {
      for (let i = 0; i < modals.length; i++) {
        modals[i].click();
      }
    }
  } catch (error) {}
};
